<div
  class="fixed top-0 right-0 left-0 z-50 bg-white h-[80px] md:h-[105px] border-b border-[#191E20] bg-[#fdfdfdf2]"
  [ngClass]="[className ? className : '']">
  <header class="flex h-full justify-start gap-4 items-center px-[10px] lg:pr-[74px] lg:pl-[60px] md:mx-20">
    <div class="md:hidden flex items-centers w-[28px] h-[25px]" (click)="handleOnClick()" *ngIf="!isAuth">
      <img alt="menu" src="assets/icons/menu-mobile.svg" />
    </div>
    <a [href]="logoURL">
      <img src="assets/logo/ionia_logo.svg" alt="logo" />
    </a>
    <!-- single slot transclusion here -->
    <ng-content></ng-content>
  </header>
</div>
